/**
 * Default panel image placeholders for the Attendee Mobile UX Header_Panel.
 *
 * Each section has a unique SVG gradient (1080×200 viewport) encoded as a data URL.
 * These serve as fallback backgrounds when no admin-uploaded Panel_Image exists.
 *
 * Real WebP image assets can replace these later — the interface remains the same:
 * import { DEFAULT_PANEL_IMAGES } from '@/assets/panel-defaults';
 */

import { SectionKey } from '../../components/attendee-mobile/constants';

/**
 * Generates an SVG data URL with a linear gradient background.
 * Each SVG is 1080×200 to match the Header_Panel viewport dimensions.
 * Uses base64 encoding for maximum browser compatibility (especially iOS Safari).
 */
function createGradientSvgDataUrl(
  startColor: string,
  endColor: string,
  direction: string = 'x1="0%" y1="0%" x2="100%" y2="100%"'
): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 200"><defs><linearGradient id="g" ${direction}><stop offset="0%" stop-color="${startColor}"/><stop offset="100%" stop-color="${endColor}"/></linearGradient></defs><rect width="1080" height="200" fill="url(#g)"/></svg>`;

  // Use base64 encoding — universally supported across all browsers/WebViews
  const base64 = btoa(svg);
  return `data:image/svg+xml;base64,${base64}`;
}

/**
 * Default panel images mapped by section key.
 * Each section has a visually distinct gradient to differentiate panels.
 */
export const DEFAULT_PANEL_IMAGES: Record<SectionKey, string> = {
  'my-weekend': createGradientSvgDataUrl('#1a6b3c', '#2dd4bf'),
  'guest-toolkit': createGradientSvgDataUrl('#7c3aed', '#c084fc'),
  'events-schedule': createGradientSvgDataUrl('#dc2626', '#f97316'),
  'marketplace': createGradientSvgDataUrl('#0369a1', '#38bdf8'),
  'announcements': createGradientSvgDataUrl('#b45309', '#fbbf24'),
  'chapters': createGradientSvgDataUrl('#0f766e', '#5eead4'),
  'krio-fun-facts': createGradientSvgDataUrl('#be185d', '#f472b6'),
  'knowledge-base': createGradientSvgDataUrl('#4338ca', '#818cf8'),
  'my-story': createGradientSvgDataUrl('#92400e', '#fcd34d'),
  'settings': createGradientSvgDataUrl('#374151', '#9ca3af'),
};
